export default __webpack_public_path__ + "static/media/frame_corner_bottom_right_gray.b7d38030.png";